import { css } from 'emotion';
import PropTypes from 'prop-types';
import React from 'react';

import theme from 'site-react/theme';

import { footerContentPadding, footerLineBreakBottom } from './Footer.styles';
import FooterCopyrightBlock from './FooterCopyrightBlock';
import FooterHelpBlock from './FooterHelpBlock';
import FooterList from './FooterList';
import FooterRatingBlock from './FooterRatingBlock';

import footerDefaultLinks from '../../navigation/data/footerMain';

const footerStyle = css`
  background-color: ${theme.colors.neutral900};
  color: ${theme.colors.white};
  width: 100%;
`;

const footerListWrapperStyle = css`
  ${footerContentPadding}
  ${footerLineBreakBottom}
  align-items: center;
  display: block;
  margin: 0;
  vertical-align: top;
  width: 100%;

  /* Only stack footer-list vertically for large screens */
  @media (min-width: ${theme.breakpoints.xl}px) {
    align-items: start;
    display: flex;
    justify-content: start;
  }
`;

const Footer = ({ footerLinks }) => {
  return (
    <footer className={footerStyle}>
      {footerLinks.length > 0 && (
        <div className={footerListWrapperStyle}>
          {footerLinks.map((link) => (
            <FooterList
              key={link.title}
              title={link.title}
              links={link.links}
            />
          ))}
        </div>
      )}
      <FooterRatingBlock />
      <FooterHelpBlock />
      <FooterCopyrightBlock />
    </footer>
  );
};

Footer.defaultProps = {
  /**
   * Optional: override collection of footers to be displayed
   */
  footerLinks: footerDefaultLinks,
};

Footer.propTypes = {
  /**
   * Collection of footer-links to display
   */
  footerLinks: PropTypes.arrayOf(PropTypes.shape(FooterList.propTypes)),
};
export default Footer;
